#import "../fragments/text-automation-fragment.graphql"

mutation UpdateTextAutomation($textAutomation: TextAutomationUpdateInput!) {
    textAutomationUpdate(input: $textAutomation) {
        textAutomation {
            ...TextAutomation
        }
    }
}
